import { render, staticRenderFns } from "./screenshot.vue?vue&type=template&id=166213df&scoped=true"
import script from "./screenshot.vue?vue&type=script&lang=js"
export * from "./screenshot.vue?vue&type=script&lang=js"
import style0 from "./screenshot.vue?vue&type=style&index=0&id=166213df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166213df",
  null
  
)

export default component.exports